<template>
	<div class="xhorse-home">
		<x-header :path="$path"
				  :backColor="backColor"
				  :textColor="textColor"
				  :activeTopIndex="activeIndex.top"
				  @go="activeTo"></x-header>
		<div class="banner-area" :style="aboutBannerStyle">
			<div class="banner-con" :style="aboutBannerStyle">
				<img :src="source.banner" alt="Xhorse" :style="aboutBannerStyle"/>
			</div>
		</div>
		<div class="belong-area" :class="belongClass">
			<div class="belong-con" :class="belongClass">
				<div class="top-bar" :style="topBar">
					<div class="bread-con">
						<div class="txt">
							Home/	{{ getTopBarTitle }}
						</div>
					</div>
				</div>
				<div class="item-con" :class="[activeClass]">
					<div ref="aboutSide" class="x-flow side side-bg-color z-index-lower"
						 :style="{minWidth : aboutSideStyle.minWidth}"
						 :class="[activeClass]">
						<x-side :activeSideIndex="activeIndex.side"
								:activeTopIndex="activeIndex.top"
								:aboutSideStyle="aboutSideStyle"
								:activeClass="activeClass"
								@go="activeTo"></x-side>
					</div>
					<div class="x-flow body main-bg-color z-index-upper"
						 :class="[activeClass]" :style="aboutMainStyle">
						<x-main :activeSideIndex="activeIndex.side"
								:activeTopIndex="activeIndex.top"
								@go="activeTo"></x-main>
					</div>
				</div>
			</div>
		</div>
		<x-footer></x-footer>
		<x-home :backVisible="backVisible" :backStyle="backStyle"></x-home>
	</div>
</template>

<script>
    import xHeader from '@/components/zh-cn/header.vue'
    import xFooter from '@/components/zh-cn/footer.vue'
    import xSide from '@/components/zh-cn/side.vue'
    import xMain from '@/components/zh-cn/main.vue'

    import banner_new1 from '@/assets/resource/images/news/banner_news_01.png'
    import banner_new2 from '@/assets/resource/images/news/banner_news_01.png'
    import banner_new3 from '@/assets/resource/images/news/banner_news_01.png'

    import coreLib from '@/lib/common'
    export default {
        components: {
            xHeader: xHeader,
            xFooter: xFooter,
            xHome: () => import('@/components/zh-cn/home'),
            xSide: xSide,
            xMain: xMain
        },
        data: function () {
            return {
                textColor: '#2A2E2E',
                backColor: '#FFFFFF',
                topBar: {
                    height: '3.4375rem'
                },
                source: {
                    banner: banner_new1,
                },
                activeIndex: {
                    top: [],
                    side: []
                },
                activeClass: '',
                belongClass: '',
                aboutBannerStyle: {},
                aboutSideStyle: {},
                aboutMainStyle: {},
                backVisible: false,
                backStyle: {
                    bottom: '3rem'
                }
            };
        },
        methods: {
            activeTo(params){
                //console.log("Template[news]: ", params)
                const _this = this;
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime()
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    _this.$router.push({path: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else {
                    _this.activeIndex.side = params.val
                }
                window.scrollTo(0, 0);
            },
            getMainPageHeight(activeInfo) {
                const _this = this;
                var activeTop = activeInfo.top;
                var activeSide = activeInfo.side;
                var assem = [activeTop[0], activeSide[0]];
                switch (assem.join(',')) {
                    case "5,1":
                        _this.activeClass = 'news-xhorse-class';
                        _this.belongClass = 'belong-area-for-xhorse-class';
                        break;
                    case "5,2":
                        _this.activeClass = 'news-detail-class';
                        break;
                    default:
                        _this.activeClass = 'news-xhorse-class';
                        _this.belongClass = 'belong-area-for-xhorse-class';
                        break;
                }
            },
            onAboutScroll(){
                const _this = this;
                const aboutSide = _this.$refs.aboutSide;
                try {
                    // 元素相对于浏览器的位置TOP
                    if (aboutSide.offsetTop >= 0) {
                        const SidePos = aboutSide.offsetTop;
                        //console.log("Menu[offsetTop]", SidePos)
                        // 元素相对于视窗的位置TOP
                        const SideClient = aboutSide.getBoundingClientRect();
                        const xheader = document.getElementById('x-header').getBoundingClientRect();
                        const xfooter = document.getElementById('x-wrap-footer').getBoundingClientRect();
                        const viewHeight = window.screen.availHeight;
                        const viewWidth = window.screen.availWidth;
                        if (SideClient.top < 0) {
                            _this.aboutSideStyle = {
                                position: 'fixed',
                                height: '100%',
                                background: 'none',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            };
                        } else {
                            _this.aboutSideStyle.position = '';
                        }
                        if (xheader.top < _this.$visibleHomeTop) {
                            _this.backVisible = true;
                            if ((xfooter.top / 16) <= (viewHeight / 16)) {
                                const realBottomEm =
                                ((viewHeight - xfooter.top) / 16) < 30 ?
                                (30 + 0.8125 + 'rem') : (((viewHeight - xfooter.top) / 16) + 0.8125 + 'rem');
                                const realBottomPx = (viewHeight - xfooter.top) + 'px';
                                _this.backStyle.bottom = viewWidth > 1280 ? realBottomPx : realBottomEm;
                            } else {
                                _this.backStyle.bottom = '3rem';
                            }
                        } else {
                            _this.backVisible = false;
                        }
                    }
                } catch (err) {
                    //console.log(err)
                }

            }
        },
        watch: {
            'activeIndex.top': function (val) {
                const _this = this;
                switch (parseInt(val[1])) {
                    case 1:
                        _this.source.banner = banner_new1;
                        break;
                    case 2:
                        _this.source.banner = banner_new2;
                        break;
                    case 3:
                        _this.source.banner = banner_new3;
                        break;
                }
            },
            activeIndex: {
                handler(activeInfo){
                    const _this = this;
                    _this.getMainPageHeight(activeInfo);
                    //console.log("监听：", activeInfo)
                },
                deep: true
            }
        },
        computed: {
            getTopBarTitle: function () {
                const _this = this;
                const activeTop = _this.activeIndex.top;
                var activeTitle = 'Going Global';
                return activeTitle;
            }
        },
        mounted(){
            const _this = this;
            const isMobile = coreLib._isMobile();
            const activePath = _this.$store.state;
            if (activePath.activeTop.length > 0 && activePath.activeSide.length > 0) {
                _this.activeIndex.top = activePath.activeTop;
                _this.activeIndex.side = activePath.activeSide;
            } else {
                _this.activeIndex.top = [3, 1, 0];
                _this.activeIndex.side = [1];
            }
            $("#x-header .h-li").css({color: '#2A2E2E'});
            // 监听滚动事件
            window.addEventListener('scroll', _this.onAboutScroll);
            const screenWh = document.body.clientWidth;
            /*_this.aboutBannerStyle['minHeight'] = ((parseInt(screenWh) * 482) / 1920 / 16) + 'rem';*/
        },
        destroyed() {
            const _this = this;
            window.removeEventListener('scroll', _this.onAboutScroll, false);
        },
        beforeRouteLeave (to, from, next) {
                 if(['/software','/xhorseIM','/download'].includes(to.path)){
                next(true)
                return
             }
            const _this = this;
            var data = {
                side: _this.activeIndex.side,
                top: _this.activeIndex.top,
            };

            if (to.params.hasOwnProperty('activeTop') && to.params.hasOwnProperty('activeSide')) {
                data.side = to.params.activeSide;
                data.top = to.params.activeTop;
            }
            //console.log("News[data]", data)
            _this.$store.commit('setActivePath', {
                type: 'all',
                val: data
            });
            window.removeEventListener('scroll', _this.onAboutScroll);
            next(true)
        }
    }

</script>

<style scoped>

	@import "../../assets/css/news.css";

</style>



// WEBPACK FOOTER //
// src/components/zh-cn/news.vue